import { isArray, mergeWith } from 'lodash';
export const concatArraysCustomizer = (objValue, srcValue) => {
    if (isArray(objValue)) {
        return objValue.concat(srcValue);
    }
    return undefined;
};
export const DEFAULT_ZONE = 'default_zone';
export const NO_ZONE = 'no_zone';
export const byZone = (blocks, zones) => {
    if (!zones) {
        return { [DEFAULT_ZONE]: blocks.map((b) => b.block) };
    }
    const zoneNames = Object.keys(zones);
    const groupedBlocks = blocks.map((block) => {
        var _a;
        const zone = (_a = zoneNames.find((z) => zones[z].includes(block.blockId))) !== null && _a !== void 0 ? _a : DEFAULT_ZONE;
        return { zone, block: block.block };
    });
    const uniqueZones = Array.from(new Set(groupedBlocks.map(({ zone }) => zone)));
    return Object.fromEntries(uniqueZones.map((zone) => [
        zone,
        groupedBlocks
            .filter(({ zone: blockZone }) => blockZone === zone)
            .map(({ block }) => block),
    ]));
};
export const withCustomZones = (template, customZones) => {
    const blockIds = Object.values(customZones).flat();
    const zones = Object.fromEntries(Object.keys(template.zones).map((zone) => [
        zone,
        template.zones[zone].filter((blockId) => !blockIds.includes(blockId)),
    ]));
    return mergeWith(Object.assign(Object.assign({}, template), { zones }), {
        zones: customZones,
    }, concatArraysCustomizer);
};
//# sourceMappingURL=index.js.map